<template>

    <div class="container">

        <app-head :title="service.meta_title || service.title">
            <meta name="description" :content="service.meta_description" v-if="service.meta_description">
        </app-head>

        <article class="service">

            <div class="my-4 service__title">
                <h1>{{ service.title }}</h1>
            </div>

            <div class="service__content" v-html="service.content">
            </div>

        </article>

    </div>

</template>

<script>

    export default {
        props: [
            'service',
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>